import {
  AuthClient,
  BitacoraClient,
  HttpClient,
  LocalStorageTokenStorage,
  SimulacionClient,
  WebSocketClient,
  type TokenStorage,
} from '@alter/api-client';
import { getEnv } from '../env';

export interface Api {
  tokenStorage: TokenStorage;
  httpClient: HttpClient;
  authClient: AuthClient;
  simulacionClient: SimulacionClient;
  bitacoraClient: BitacoraClient;
  /** Único cliente WS de la app. La sesión suscribe y se desuscribe al salir. */
  wsClient: WebSocketClient;
}

let _api: Api | null = null;

/**
 * Inicializa los singletons de `@alter/api-client`. Debe llamarse desde
 * `main.tsx` después de `setEnv`. Idempotente — múltiples llamadas
 * devuelven la misma instancia.
 *
 * El `X-Client-Type` no se configura acá: `HttpClient` envía siempre la
 * constante `web` (nota de interfaz §2).
 */
export function bootstrapApi(): Api {
  if (_api) return _api;
  const env = getEnv();
  const tokenStorage = new LocalStorageTokenStorage(window.localStorage);
  const httpClient = new HttpClient({
    restBaseUrl: env.VITE_API_BASE_URL,
    tokenStorage,
  });
  _api = {
    tokenStorage,
    httpClient,
    authClient: new AuthClient(httpClient, tokenStorage),
    simulacionClient: new SimulacionClient(httpClient),
    bitacoraClient: new BitacoraClient(httpClient),
    wsClient: new WebSocketClient({ wsBaseUrl: env.VITE_WS_BASE_URL, tokenStorage }),
  };
  return _api;
}

/** Acceso a las instancias. Lanza si `bootstrapApi()` no se llamó aún. */
export function getApi(): Api {
  if (!_api) {
    throw new Error('bootstrapApi() must be called before getApi()');
  }
  return _api;
}
